import React from "react";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

const SignOutButton = ({ handleSignOut, mobileOpen }) => (
  <List>
    <ListItem button onClick={handleSignOut}>
      <ListItemIcon style={{color:"red"}}>
        <LogoutIcon style={{ transform: "rotate(180deg)" }} />
      </ListItemIcon>
      {mobileOpen && <ListItemText primary="Sign Out" />}
    </ListItem>
  </List>
);

export default SignOutButton;